import FeaturesCard from "../../components/client/FeaturesCard";
import DownloadAppCard from "../../components/client/DownloadAppCard";
import PromotionalSlider from "../../components/client/PromotionalSlider";
import PopularCategories from "../../components/client/PopularCategories";
import PromotionalBanners from "../../components/client/PromotionalBanners";
import TrendingProducts from "../../components/client/TrendingProducts";
import HomePromoProducts from "../../components/client/HomePromoProducts";
import HomeNewProducts from "../../components/client/HomeNewProducts";
import ClientLayout from "../../layouts/ClientLayout";
import PageMeta from "../../components/common/PageMeta";
import { STATIC_PAGES } from "../../config/seo";
import PromotionsSection from "../../components/client/PromotionsSection";
import Section2BannerCarousel from "../../components/client/Section2BannerCarousel";


const Home = () => {
  return (
    <ClientLayout>
      <PageMeta {...STATIC_PAGES.home} />
      <div className="flex-1 md:mx-8 lg:mx-16 mx-auto relative">
        <PromotionalSlider />
        <FeaturesCard />
        <PopularCategories />
        <TrendingProducts />
        <PromotionsSection />
        <DownloadAppCard />
      </div>

      <Section2BannerCarousel />

      <div className="flex-1 md:mx-8 lg:mx-16 mx-auto relative mt-8">
        <HomePromoProducts />
        <PromotionalBanners />
        <HomeNewProducts />
      </div>
    </ClientLayout>
  );
};

export default Home; 